const SyncSlider = ( ( window, $, undefined ) => {

  const itemsTransitionSpeed = 600;
  const mediaSliderSettings = {
    loop: false,
    items: 1,
    dots: false,
    nav: false,
    smartSpeed: itemsTransitionSpeed,
  };

  const contentSliderSettings = {
    loop: false,
    items: 1,
    dots: true,
    navText:[],
    nav: true,
    smartSpeed: itemsTransitionSpeed,
    transitionStyle : "fade"
  };

  let mediaSlider, contentSlider;

  const _contentSliderInit = () => {
    contentSlider = $(".fc_dual_carousel__content_carousel").owlCarousel(contentSliderSettings);
  };

  const _mediaSliderInit = () => {
    mediaSlider = $(".fc_dual_carousel__media_carousel").owlCarousel(mediaSliderSettings);
  };

  const _onChangeSlidersSync = () => {
    mediaSlider.on('changed.owl.carousel', event => contentSlider.trigger('to.owl.carousel', [event.item.index, itemsTransitionSpeed, true]) );
    contentSlider.on('changed.owl.carousel', event => mediaSlider.trigger('to.owl.carousel', [event.item.index, itemsTransitionSpeed, true]) );
  }

  const init = () => {
    _contentSliderInit();
    _mediaSliderInit();
    _onChangeSlidersSync();
  };

  return {
    init: init
  };

})( window, jQuery );